import { render, staticRenderFns } from "./GralTable.vue?vue&type=template&id=fd899f96&"
import script from "./GralTable.vue?vue&type=script&lang=js&"
export * from "./GralTable.vue?vue&type=script&lang=js&"
import style0 from "./GralTable.vue?vue&type=style&index=0&id=fd899f96&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports